import { useReportDetail } from "../ReportDetailProvider";

/** True only when the report's calculated blueprint recorded Lens Topics at create time. */
export function useLensTopicsEnabled(): boolean {
  const { blueprint } = useReportDetail();
  return blueprint?.lens_topics_enabled === true;
}
